module.exports = __webpack_public_path__ + "img/referral-settings.98bd8c4c.png";